import ApiService from "@/services/api.service";

const route = 'proposals';

import Vue from 'vue';

const proposals = {
    all(_limit, _currentPage, _params) {
        return new Promise((resolve, reject) => {
            var params = "?limit=" + _limit + "&page=" + _currentPage;

            if(_params.interval)
            {
                if (_params.interval[0] && _params.interval[1]) {
                    params += "&init_at=" + Vue.moment(_params.interval[0]).format('YYYY-MM-DD')
                            + "&end_at=" + Vue.moment(_params.interval[1]).format('YYYY-MM-DD');
                }
            }

            if (_params.date_filter) {
                params += "&date_filter=" + _params.date_filter;
            }

            if (_params.salesman_id != null) {
                params += "&salesman_id=" + _params.salesman_id;
            }

            if (_params.proposal_status_id != null) {
                params += "&proposal_status_id=" + _params.proposal_status_id;
            }

            if (_params.branch_id != null) {
                params += "&branch_id=" + _params.branch_id;
            }

            if (_params.administrator_id != null) {
                params += "&administrator_id=" + _params.administrator_id;
            }

            if (_params.team_id != null) {
                params += "&team_id=" + _params.team_id;
            }

            if (_params.assembly_deadline != null) {
                params += "&assembly_deadline=" + _params.assembly_deadline;
            }

            if (_params.client !== undefined && _params.client.name != null) {
                params += "&client[name]=" + _params.client.name;
            }

            if (_params.group_id != null) {
                params += "&group_id=" + _params.group_id;
            }

            if (_params.quota != null) {
                params += "&quota=" + _params.quota;
            }

            if (_params.physical_proposal != null) {
                params += "&physical_proposal=" + _params.physical_proposal;
            }

            if(_params.client_name != null)
                params += "&client_name=" + encodeURI(_params.client_name);

            ApiService.get(route + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    get(_id) {
        return new Promise((resolve, reject) => {
            ApiService.get(route + "/" + _id).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    print(_id) {
        return new Promise((resolve, reject) => {
            ApiService.download(route, _id + "/pdf").then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    getCockpit(_initAt, _endAt, _salesmanId) {
        return new Promise((resolve, reject) => {
            ApiService.get(route, "cockpit?initAt=" + Vue.moment(_initAt).format('YYYY-MM-DD') + "&endAt=" + Vue.moment(_endAt).format('YYYY-MM-DD') + "&salesmanId=" + _salesmanId)
                    .then(({data}) => {
                        resolve(data);
                    }, (error) => {
                        reject(error);
                    });
        });
    },
    add(_module) {
        return new Promise((resolve, reject) => {
            const params = Object.assign({}, _module);

            if (params.proposal.sale_at != undefined && params.proposal.sale_at != '') {
                params.proposal.sale_at = Vue.moment(params.proposal.sale_at).format('YYYY-MM-DD');
            }

            // if (params.proposal.meeting_at != undefined && params.proposal.meeting_at != '') {
            //     params.proposal.meeting_at = Vue.moment(params.proposal.meeting_at).format('YYYY-MM-DD');
            // }

            if (params.proposal.first_meeting_at != undefined && params.proposal.first_meeting_at != '') {
                params.proposal.first_meeting_at = Vue.moment(params.proposal.first_meeting_at).format('YYYY-MM-DD');
            }

            if (params.proposal.first_meeting_at != undefined && params.proposal.first_meeting_at != '') {
                params.proposal.first_meeting_at = Vue.moment(params.proposal.first_meeting_at).format('YYYY-MM-DD');
            }

            if (params.proposal.installment_due != undefined && params.proposal.installment_due != '') {
                params.proposal.installment_due = Vue.moment(params.proposal.installment_due).format('YYYY-MM-DD');
            }

            ApiService.post(route, params).then(({ data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    validProtocol(_params) {
        return new Promise((resolve, reject) => {
            const params = "?administrator_id=" + _params.administrator_id + "&physical_proposal=" + _params.physical_proposal;

            ApiService.get(route + "/valid-protocol" + params).then(({ data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    edit(_id, _module) {
        return new Promise((resolve, reject) => {
            const params = Object.assign({}, _module);

            if (params.invoice_at != undefined && params.invoice_at != '') {
                params.invoice_at = Vue.moment(params.invoice_at).format('YYYY-MM-DD');
            }

            if (params.cancel_at != undefined && params.cancel_at != '') {
                params.cancel_at = Vue.moment(params.cancel_at).format('YYYY-MM-DD');
            }

            if (params.contemplate_at != undefined && params.contemplate_at != '') {
                params.contemplate_at = Vue.moment(params.contemplate_at).format('YYYY-MM-DD');
            }

            if (params.meeting_at != undefined && params.meeting_at != '') {
                params.meeting_at = Vue.moment(params.meeting_at).format('YYYY-MM-DD');
            }

            if (params.first_meeting_at != undefined && params.first_meeting_at != '') {
                params.first_meeting_at = Vue.moment(params.first_meeting_at).format('YYYY-MM-DD');
            }

            if (params.contemplate_at != undefined && params.contemplate_at != '') {
                params.contemplate_at = Vue.moment(params.contemplate_at).format('YYYY-MM-DD');
            }

            if (params.in_default_at != undefined && params.in_default_at != '') {
                params.in_default_at = Vue.moment(params.in_default_at).format('YYYY-MM-DD');
            }

            if (params.deployment_at != undefined && params.deployment_at != '') {
                params.deployment_at = Vue.moment(params.deployment_at).format('YYYY-MM-DD');
            }

            ApiService.put(route, _id, params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    payInstallment(_id, _params) {
        return new Promise((resolve, reject) => {
            const params = Object.assign({}, _params);
            ApiService.post(route + "/" + _id + "/installments/" + _params.installment_id + "/pay", params.payments).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    reversePayInstallment(_id, _params) {
        return new Promise((resolve, reject) => {
            ApiService.delete(route + "/" + _id + "/installments/" + _params.installment_id + "/pay", Vue.moment(_params.reversal_at).format('YYYY-MM-DD')).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    editInstallment(_id, _params) {
        return new Promise((resolve, reject) => {
            const params = Object.assign({}, _params);
            ApiService.put(route + "/" + _id + "/installments", _params.installment_id , params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    rem(_id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(route, _id)
                    .then(({ data }) => {
                        resolve(data);
                    }, (error) => {
                        reject(error);
                    });
        });
    },
    duplicateProposal(params){

        return new Promise((resolve, reject) => {
            ApiService.post(route+'/duplicate', params).then(({ data }) => {
                                            resolve(data);
                                        }, (error) => {
                                            reject(error);
                                        });
        })
    }
};

export default proposals;
